@if (this.otpFormService.currentStep !== -1) {

<app-auth-layout>
  <ng-container [ngSwitch]="this.otpFormService.currentStep">
    <!-- đổi pass -->
    <form-sso-change-password
      *ngSwitchCase="this.otpFormService.CONTROLER_STEP.CHANGE_PASSWORD"
    >
    </form-sso-change-password>

    <!-- đổi số điện thoại -->

    <app-sso-form-email
      *ngSwitchCase="this.otpFormService.CONTROLER_STEP.VERIFY_EMAIL"
    >
    </app-sso-form-email>

    <app-sso-finished-form
      *ngSwitchCase="this.otpFormService.CONTROLER_STEP.FINISH"
    />

    <app-sso-verify-device
      *ngSwitchCase="this.otpFormService.CONTROLER_STEP.VERIFY_DEVICE"
    ></app-sso-verify-device>

    <app-sso-auth-verify-phone
      *ngSwitchCase="this.otpFormService.CONTROLER_STEP.VERIFY_PHONE_NUMBER"
    ></app-sso-auth-verify-phone>

    <app-sso-input-otp
      *ngSwitchCase="this.otpFormService.CONTROLER_STEP.VERIFY_OTP"
    ></app-sso-input-otp>
    <!-- default case if none of the above matches -->
    <div *ngSwitchDefault>
      <!-- Handle default case if needed -->
    </div>
  </ng-container>
  <div class="oauth__cannot_login text-center">
    <hr class="my-4" />
    <!-- <span>Trợ giúp? </span> -->
    <!-- <a [href]="this.support_link" target="_blank" class="hover-underline cursor-pointer">Xem hướng dẫn tại đây</a> -->
    <a
      (click)="navigateToLogin()"
      class="hover-underline fw-400 text-muted cursor-pointer"
      >Đăng nhập bằng tài khoản khác</a
    >
  </div>
</app-auth-layout>
} @else {
<app-auth-layout *transloco="let translated">
  <div class="p-3">
    <div class="d-flex align-items-center">
      <strong
        >{{
          translated("auth.component.accountfirstLogin.loadingMessage")
        }}...</strong
      >
      <div
        class="spinner-border ml-auto"
        role="status"
        aria-hidden="true"
      ></div>
    </div>
  </div>
</app-auth-layout>
}
